import { Component, OnDestroy, OnInit } from '@angular/core';
import { Discount, PromoType } from 'anchor-shared/lib/model/entity/discount';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { UserDAO } from '../../../../../core/services/dao/userDAO';
import { DiscountDAO } from '../../../../../core/services/dao/discountDAO';
import { ApiHelper } from '../../../../../core/services/apiHelper';
import { AdminAccess } from '../../../../shared/accessAdmin';
import { Subscription } from 'rxjs';
import { ContainsSubscriptions } from '../../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../../core/pure-functions/rx-helper';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-coupon-form',
  templateUrl: './coupon-form.component.html',
  styleUrls: ['./coupon-form.component.scss'],
})
export class CouponFormComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  public formTitle: string;

  charterPromoType: PromoType = PromoType.CHARTER;
  c4hPromoType: PromoType = PromoType.CAPTAIN_FOR_HIRE;

  public model: Discount = {
    code: null,
    active: true,
    amount: null,
    percentageBased: false,
    promoType: PromoType.CHARTER,
    promoDescription: null,
  };

  public isEditing: boolean;

  subs: Subscription[] = [];
  promoForm: FormGroup;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userDAO: UserDAO,
    private discountDAO: DiscountDAO,
    private apiHelper: ApiHelper,
    private checkAdmin: AdminAccess,
  ) {
    this.checkAdmin.checkAdminAccess(this.userDAO, this.apiHelper, this.router);
  }

  ngOnInit() {
    const isEditingSub = this.route.url
      .map(
        (urlArray: UrlSegment[]) =>
          urlArray.map((url: UrlSegment) => url.path).indexOf('edit') >= 0,
      )
      .subscribe((isOnEditScreen: boolean) => {
        this.isEditing = isOnEditScreen;

        if (this.isEditing) {
          const paramsSub = this.route.params.subscribe((params) => {
            const promoSub = this.discountDAO
              .getById(params.id)
              .subscribe((discount) => {
                this.model = discount;
              });
            this.subs.push(promoSub);
          });
          this.subs.push(paramsSub);
        }
      });
    this.subs.push(isEditingSub);

    this.promoForm = new FormGroup({
      promoName: new FormControl(this.model.code, Validators.required),
      promoType: new FormControl(
        { status: this.model.promoType },
        Validators.required,
      ),
      promoAmount: new FormControl(this.model.amount, Validators.required),
      percentageBased: new FormControl(
        { status: this.model.percentageBased },
        Validators.required,
      ),
      promoDescription: new FormControl(this.model.promoDescription),
      promoActive: new FormControl(
        { status: this.model.active },
        Validators.required,
      ),
    });
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  public cancel() {
    this.router.navigate(['manage/admin/coupons']);
  }

  public submit() {
    if (this.isEditing) {
      this.discountDAO.serverUpdate(this.model).subscribe((result) => {
        this.router.navigate(['manage/admin/coupons']);
      });
    } else {
      this.discountDAO.serverCreate(this.model).subscribe((result) => {
        this.router.navigate(['manage/admin/coupons']);
      });
    }
  }

  positiveNumberOnly(event): Boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode === 45) {
      return false;
    }
    return true;
  }

  createPromo() {
    let promoSub = null;
    this.model.code = this.model.code.toUpperCase();
    if (this.isEditing) {
      promoSub = this.discountDAO
        .serverUpdate(this.model)
        .subscribe((result) => {
          this.router.navigate(['manage/admin/coupons']);
        });
    } else {
      promoSub = this.discountDAO.create(this.model).subscribe(() => {
        this.router.navigate(['manage/admin/coupons']);
      });
    }
    this.subs.push(promoSub);
  }
}
